import { ReactNode } from 'react';
import styled from 'styled-components';
import { Switch } from 'components/atoms/switch/switch';
import { BodyShort01 } from 'components/styles';

export const Description = styled.div`
  ${BodyShort01};
  color: var(--gray-70);
  margin-top: var(--spacing-02);
  margin-bottom: var(--spacing-05);
`;

const Title = styled.p`
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: 1.75rem;
  margin: 0;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
  border-radius: var(--border-radius-small);
  border: 1px solid var(--gray-10);
  background: var(--gray-15);
  padding: var(--spacing-04) var(--spacing-05) var(--spacing-05)
    var(--spacing-05);
`;

interface GlobalSettingsEnableSwitcherProps {
  enableSetting: boolean;
  onChangeSettings: (value: boolean) => void;
  dataCy: string;
  title: ReactNode;
  description: ReactNode;
  isDisabled?: boolean;
}

export const GlobalSettingsEnableSwitcher = ({
  enableSetting,
  onChangeSettings,
  dataCy,
  title,
  description,
  isDisabled,
}: GlobalSettingsEnableSwitcherProps) => {
  return (
    <Wrapper>
      <Switch
        checked={enableSetting}
        onChange={onChangeSettings}
        data-cy={dataCy}
        disabled={isDisabled}
      />
      <div>
        <>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </>
      </div>
    </Wrapper>
  );
};
